import { render, staticRenderFns } from "./AccountFormView.vue?vue&type=template&id=03d58bd0&scoped=true&"
import script from "./AccountFormView.vue?vue&type=script&lang=js&"
export * from "./AccountFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d58bd0",
  null
  
)

export default component.exports